import { Typography, LinearProgress, Box } from '@mui/material';

export default function LinearProgressWithLabel({ value }) {
  return (
    <Box display="flex" alignItems="center">
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={value} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="textSecondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
